<script lang="ts">
    import { ArrowsPointingOut, Banknotes, Identification } from 'svelte-heros';
    const icons = [Banknotes, Identification, ArrowsPointingOut]
    export let section: Section;
    export let index: number;
</script>

<div class="bg-white py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl lg:mx-0">
            {#if index === 0}
                <h1 class="text-5xl font-display font-bold tracking-tight text-gray-900 sm:text-6xl">{section.title}</h1>
            {:else}
                <h2 class="text-4xl font-display font-bold tracking-tight text-gray-900 sm:text-5xl">{section.title}</h2>
            {/if}

            <p class="mt-6 text-lg leading-8 text-gray-600">
                {section.description}
            </p>
        </div>
        <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
            <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
                {#each section.blocks as block, index}
                    <div class="flex flex-col">
                        <dt class="text-base font-semibold leading-7 text-gray-900">
                            <div class="mb-6 flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500">
                                <svelte:component this={icons[index]} class="w-6 h-6 text-white" />
                            </div>
                            {block.title}
                        </dt>
                        <dd class="mt-1 flex flex-auto flex-col text-base leading-7 text-gray-600">
                            <p class="flex-auto">
                                {block.description}
                            </p>
                            {#if block.linkTitle}
                                <p class="mt-6">
                                    <a href={block.linkUrl} class="text-sm font-semibold leading-6 text-primary-500">{block.linkTitle} <span aria-hidden="true">→</span></a>
                                </p>
                            {/if}
                        </dd>
                    </div>
                {/each}
            </dl>
        </div>
    </div>
</div>
